import { Box, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import Text from "src/components/Displays/Text";
import PageSubTitle from "../Displays/PageSubTitle";
import { SITE_AUTHENTICATION_PATHS } from "src/consts/paths";
import { SITE_AUTHENTICATION_ROUTES } from "src/consts/routes";
import VerticalLinearProgress from "../ProgressBar/VerticalLinearProgressBar";

export const tariffCalculator = (pathname: string) => {
  switch (pathname) {
    case SITE_AUTHENTICATION_ROUTES.SUCCESS:
      return 55;
    case SITE_AUTHENTICATION_ROUTES.FAILED:
      return 55;
    default:
      return 0;
  }
};

const SiteAuthenticationProgressBar = () => {
  const { pathname } = useLocation();

  return (
    <Stack
      gap="13px"
      sx={{
        display: { xs: "none", sm: "flex" },
      }}
    >
      <Text
        text={"Menü"}
        sx={(theme) => ({
          color: theme.palette.mainFont.primary,
          fontSize: "32px",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: "35px",
        })}
      />

      {SITE_AUTHENTICATION_PATHS.includes(pathname) && (
        <Box
          sx={{
            gap: 3,
            height: 55,
            display: { xs: "flex", sm: "default" },
          }}
        >
          <VerticalLinearProgress
            variant="determinate"
            value={55 - tariffCalculator(pathname)}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <PageSubTitle text={"Hardware Zugriff"} />
            <PageSubTitle text={"Status"} />
          </Box>
        </Box>
      )}
    </Stack>
  );
};

export default SiteAuthenticationProgressBar;
